var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppModal",
    {
      attrs: {
        id: "rename-mfa-modal",
        title: _vm.$t("Rename 2FA method"),
        action: "Save",
        disableAction: !_vm.newName.trim(),
        secondaryAction: "Cancel"
      },
      on: {
        close: _vm.closeModal,
        cta: _vm.save,
        "secondary-cta": _vm.closeModal
      }
    },
    [
      _c("AppInput", {
        key: _vm.stateChangeKey,
        staticClass: "mt-2 mb-1 form-group",
        attrs: {
          placeholder: _vm.$t("Enter authenticator name"),
          error:
            _vm.ajaxError &&
            _vm.ajaxError.errors &&
            _vm.ajaxError.errors.newName,
          name: "authenticator-name"
        },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.save.apply(null, arguments)
          }
        },
        model: {
          value: _vm.newName,
          callback: function($$v) {
            _vm.newName = $$v
          },
          expression: "newName"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }